import { FC } from 'react';
import styled from 'styled-components';
import Icon, { ICON_SPINNER_LINE } from '../../../icon/index';

const AnimatedSpinner = styled(Icon).attrs({ type: ICON_SPINNER_LINE })`
	@keyframes rotating {
		from {
			transform: rotate(0deg);
		}
		to {
			transform: rotate(360deg);
		}
	}

	animation: rotating 900ms linear infinite;
	color: var(--sportsbook-loading-spinner-color, var(--sportsbook-text-supportive));
`;

type Props = {
	width?: number;
	height?: number;
	className?: string;
};

const LoadingSpinner: FC<Props> = ({ width, height, className }) => (
	<AnimatedSpinner type={ICON_SPINNER_LINE} className={className} width={width} height={height} />
);

export default LoadingSpinner;
